import "./ButtonNotice.css";
import newSuccesIcon from "./img/circle-check.webp";
import { useTranslation } from 'react-i18next';

export const ButtonNotice = (props) => {
  const { domState, mitigationAction } = props;
  const { t } = useTranslation();
  const mitigationActionWithCapitalLetter = `${mitigationAction
    .charAt(0)
    .toUpperCase()}${mitigationAction.slice(1)}`;
  const setActionSuccessAndFailureMessages = (mitigationAction) => {
    let message = {
      failure: t('transaction_failed'),
      success: t('transaction_success'),
    };
    // let message = {};
    // if (mitigationAction === "verify") {
    //   message = {
    //     success: "Verification Success",
    //     failure: "Verification Failed",
    //   };
    // }
    // if (mitigationAction === "authorize") {
    //   message = {
    //     success: "Authorization Success",
    //     failure: "Authorization Failed",
    //   };
    // }
    return message;
  };
  const mitigationActionCompletionMessages =
    setActionSuccessAndFailureMessages(mitigationAction);
  return (
    <div>
      <div
        className={
          domState === "verification_success"
            ? "verification-notice"
            : "regular-notice"
        }
      >
        {domState === "verification_success" && 
        <p
          className={"notice-text-verified"}
        >
            {`${mitigationActionCompletionMessages.success}`}
        </p>}
        
        {domState === "default" && (
          <p
            className={"notice-text"}
          >
            {/* {`${mitigationActionWithCapitalLetter} my Credit Card`} */}
            {t("place_order_button")}
          </p>
        )}
        {domState === "verification_failure" && (
          <p
            className={
              domState === "verification_failure"
                ? "notice-text-verification-failed"
                : "notice-text"
            }
          >
            {mitigationActionCompletionMessages.failure}
          </p>
        )}
        {domState === "verification_success" ? (
          <img src={newSuccesIcon} alt="" className="success-icon" />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
